module.exports = __webpack_public_path__ + "img/foodindustry_1.4d1daa24.jpg";